import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { detectIOS } from '../../../utilities/helperUtility';
import { StyledSelect } from './Select.style';
import SlotLabel from '../../../page/components/SlotLabel';

export default class Select extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedTimeslot: props.value || this.getDefaultOption(),
      prevSelectedTimeslot: this.getDefaultOption(),
    };

    this.selectRef = React.createRef();

    this.handleOptionHover = this.handleOptionHover.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onResetToPrev = this.onResetToPrev.bind(this);
  }

  componentDidUpdate(oldProps) {
    if (JSON.stringify(oldProps) === JSON.stringify(this.props)) {
      return;
    }

    const { value, onChange, disableDefaultOption } = this.props;

    if (!value && !disableDefaultOption) {
      const defaultOption = this.getDefaultOption();
      this.setState({ selectedTimeslot: defaultOption });
      onChange(defaultOption);
    } else {
      this.setState({ selectedTimeslot: value });
    }
  }

  componentDidMount() {
    if (detectIOS() && !window.matchMedia('(pointer:fine)').matches) {
      this.selectRef.current.onOptionHover = this.handleOptionHover;
    }
  }

  handleOptionHover(newValue) {
    const { onOptionHover, selectOption } = this.selectRef.current;

    onOptionHover(newValue);
    selectOption(newValue);
  }

  getDefaultOption() {
    const {
      options, useValueAsDefault, value, allowSelectOption, isMulti,
    } = this.props;

    const filteredOptions = options.filter((x) => !x.disabled);
    let defaultOptions = filteredOptions.length > 0 ? filteredOptions[0].value : '';

    if (useValueAsDefault) {
      defaultOptions = value;
    } else if (allowSelectOption) {
      defaultOptions = '';
    }

    if (!isMulti) {
      return defaultOptions;
    }

    if (!defaultOptions) {
      return [];
    }

    return [defaultOptions];
  }

  onChange(data) {
    const { isMulti, onChange } = this.props;
    const { selectedTimeslot: previousSelected } = this.state;
    let value = data ? data.value : null;

    if (isMulti) {
      value = data ? data.map((option) => option.value) : [];
    }

    this.setState({
      prevSelectedTimeslot: previousSelected,
      selectedTimeslot: value,
    });
    onChange(value);
  }

  // Reset select to previous selected value.
  onResetToPrev() {
    const { onResetToPrev } = this.props;
    const { prevSelectedTimeslot } = this.state;

    this.setState({
      selectedTimeslot: prevSelectedTimeslot,
    });
    onResetToPrev();
  }

  getValue() {
    const { selectedTimeslot } = this.state;
    const { isMulti, options } = this.props;

    if (isMulti) {
      return options.filter((option) => selectedTimeslot.includes(option.value));
    }

    return options.find((option) => option.value === selectedTimeslot);
  }

  calculateMaxHeight() {
    const { current } = this.selectRef;
    const bodyEl = document.querySelector('body');
    if (!current || !current.controlRef || !bodyEl) return 100;

    const { clientHeight } = bodyEl;
    const { top } = current.controlRef.getBoundingClientRect();
    return clientHeight - top - 50;
  }

  render() {
    const { buildLabel, options, className } = this.props;
    const optionsList = buildLabel
      ? options.map((o) => ({ ...o, ...{ label: <SlotLabel option={o} fixed /> } }))
      : options;
    const value = this.getValue() || '';

    return (
      <StyledSelect
        ref={this.selectRef}
        {...this.props}
        id="split-button-basic-0"
        className={`styled-select ${className}`}
        value={value}
        onChange={this.onChange}
        onResetToPrev={this.onResetToPrev}
        options={optionsList}
        maxMenuHeight={this.calculateMaxHeight()}
        classNamePrefix={'bta-react-select'}
      />
    );
  }
}

Select.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
};
